import { render, staticRenderFns } from "./EditePartnerTelegramModal.vue?vue&type=template&id=71dab9f6"
import script from "./EditePartnerTelegramModal.vue?vue&type=script&lang=js"
export * from "./EditePartnerTelegramModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports